/* eslint-disable */
import _ from 'lodash';
import moment from 'moment';
import CommonUtils from 'utilities/common-utils';
import {
  FilterType,
} from 'utilities/enum-utils';

export const formatFilters = (filters) => {
  return filters
    .filter((filter) => !_.isEmpty(filter))
    .map((filter) => {
      if (_.isUndefined(filter.filter)) {
        const [[key, value]] = Object.entries(filter);
        return {
          filter: key,
          values: value || [],
          selectionLabel: !_.isEmpty(value)
            ? key === FilterType.DATE_RANGE
              ? CommonUtils.getFilterText(FilterType.DATE_RANGE, [moment(value[0]), moment(value[1])])
              : CommonUtils.getFilterText(key, value)
            : CommonUtils.getFilterSettings(key).fullSelectionName,
        };
      }
      return filter;
    });
};
